<div id="voucherCustomDetail" class="ya-typography">
  <ya-subheader [hasContent]="false" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop">
    <ng-container *ngIf="webVoucher_custom$ |async; let webVoucher">
      <ng-container *ngIf="webVoucher.hasImage; then Image else NoImage"></ng-container>
      <ng-template #Image>
        <div class="product-image-wrapper" (swiperight)="SwiperNavigateBack()">
          <div class="aspect-ratio-box">
            <div class="aspect-ratio-box-inside">
              <div class="aspect-ration-img-box">
                <ng-container *ngIf="webVoucher.hasImage">
                  <img class="ya_image" [src]="webVoucher.image" ignore_assets="1" alt="" />
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #NoImage>
        <div class="noimage-fake-subheader"></div>
      </ng-template>
      <mat-tab-group mat-stretch-tabs [(selectedIndex)]="matGroupSelectedIndex"
        (swipeleft)="displayTabs(webVoucher.has_preview) ?swipeLeftHandler():''"
        (swiperight)="displayTabs(webVoucher.has_preview) ?swipeRightHandler():''" animationDuration=" 20ms"
        class="ya-tab-group webvoucher" [ngClass]="displayTabs(webVoucher.has_preview)?'':'mat-tab-header--hidden'">
        <mat-tab>
          <ng-container *ngIf="displayTabs(webVoucher.has_preview)">
            <ng-template mat-tab-label>
              <span a11y_Button langkey="phWebVoucher_Detail_Tab_Overview"></span>
            </ng-template>
          </ng-container>
          <div class="ya-tab-content-wrapper ya-tab-content-wrapper--padding">
            <div class="webVoucher" [class.webVoucher-content--centered]="!webVoucher.has_preview">
              <div class="webVoucher-header">
                <ng-container *ngIf="webVoucher.label!==''">
                  <div class="header">
                    <div class="title ya-detail-page-header">
                      <h2>{{webVoucher.label}}</h2>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="webVoucher.description_short!==''">
                  <div class="webVoucher-description--short" innerHtml="{{webVoucher.description_short}}"></div>
                </ng-container>
              </div>
              <ng-container *ngIf="!isSmallView && (webVoucher.has_preview)">
                <div class="col">
                  <div class="webVoucher-overview">
                    <div class="webVoucher-item__layout">
                      <div class="aspect-ratio-box webVoucher-item__img">
                        <div class="aspect-ratio-box-inside">
                          <div class="aspect-ration-img-box">
                            <img class="ya_image" [src]="webVoucher.preview" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="col second">
                <div class="webVoucher-content">
                  <div class="webVoucher-price">
                    <ng-container
                      *ngIf="hasFreeAmount(webVoucher.price); then VariablePriceTemplate else FixPriceTemplate "></ng-container>
                    <ng-template #VariablePriceTemplate>
                      <div class="title">
                        <span langkey="phWebvoucher_Detail_Desired_Value"></span>
                      </div>
                      <div class="webVoucher-price--variable">
                        <div class="input-amount">
                          <div class="ya-input-container">
                            <input a11y_SpinButton class="ya-input-text" (keyup)="onInputVariablePriceChange()"
                              [formControl]="priceInputFormControl" [placeholder]="webVoucherInputPlaceholder"
                              onpaste="return false;" oncopy="return false" oncut="return false" ondrag="return false"
                              ondrop="return false" pattern="[0-9]*" inputmode="numeric"
                              (keypress)="isNumberKey($event)" (blur)="onInputVariablePriceBlur()">
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #FixPriceTemplate>
                      <div class="title">
                        <span langkey="phWebvoucher_Detail_Value"></span>
                      </div>
                      <div class="webVoucher-price--fixed">
                        <span class="price">{{priceFormatter(webVoucher.price)}}</span>
                      </div>
                    </ng-template>
                  </div>
                  <ng-container *ngIf="webVoucher.description_long_html !==''">
                    <ng-container
                      *ngIf="!isSmallView || !displayColapsable(webVoucher.description_long_html); then defaultView else colapsableView"></ng-container>
                    <ng-template #defaultView>
                      <div class="webVoucher-description--long">
                        <div class="webVoucher-description--content">
                          <p [innerHTML]="webVoucher.description_long_html"></p>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #colapsableView>
                      <div class="webVoucher-description--long" (click)="isDropDownActive = !isDropDownActive">
                        <div class="webVoucher-description--content">
                          <p [innerHTML]="customizeDescription(webVoucher.description_long_html)">
                          </p>
                        </div>
                        <div class="collapsable">
                          <ng-container *ngIf="!isDropDownActive;then showMore else showLess"></ng-container>
                          <ng-template #showMore>
                            <div class="left">+<span langkey="phWebVoucher_Detail_Show_More"></span></div>
                          </ng-template>
                          <ng-template #showLess>
                            <div class="left ">-<span langkey="phWebVoucher_Detail_Show_Less"></span></div>
                          </ng-template>
                          <div class="right" [ngClass]="{'active': isDropDownActive === true}">
                            <div class="inline-icon expand-svg" inlineSVG="shop-icons.svg#ya-expand_more"></div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="webVoucherSettings$ |async; let settings">
                    <ng-container
                      *ngIf="!hasFreeAmount(webVoucher.price) && useNumberOfPersons (settings.useNumber_of_Persons)">
                      <div class="webVoucher-person">
                        <div class="webVoucher-person__selector--label">
                          <span langkey="phWebvoucher_Detail_Number_Of_Persons"></span>
                        </div>
                        <div class="webVoucher-person__selector webshop-button webshop-button--hollow">
                          <ng-container *ngIf="countOfPersons$|async;let personCount">
                            <div class="amountchanger" (click)="changePersonCount(personCount); decrementPersonCount()">
                              <span>-</span>
                            </div>
                            <div class="amount amount-input">
                              <input a11y_SpinButton class="amount-count-input" type="text" [ngModel]="personCount"
                                (ngModelChange)="changePersonCount($event);" maxlength="2" numericInput
                                [placeholder]="personCount" (keypress)="onKeyPress($event)" inputmode="numeric"
                                onpaste="return false;" oncopy="return false" tabindex="-1" pattern="[0-9]*"
                                inputmode="numeric" oncut="return false" ondrag="return false" ondrop="return false"
                                (blur)="onBlurAmount()" (focus)="onFocusAmount($event)">
                            </div>
                            <div class="amountchanger" (click)="changePersonCount(personCount); incrementPersonCount()">
                              <span>+</span>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="usePrintAndPostDelivery(settings.delivery_settings)">
                      <div class="webVoucher-delivery__selector">
                        <div class="ya-radio-group-vertical">
                          <mat-radio-button [disableRipple]=" true" [value]="deliverySettings.Mail"
                            (change)="deliveryOptionChanged(deliverySettings.Mail,$event)"
                            [checked]="setChecked(deliveryType$|async,deliverySettings.Mail)">
                            <span langkey="phWebvoucher_Detail_Email_Delivery"></span>
                            <span class="webVoucher-delivery__info"
                              langkey="phWebvoucher_Detail_Free_Delivery"></span></mat-radio-button>
                          <mat-radio-button [disableRipple]="true" [value]="deliverySettings.Post"
                            (change)="deliveryOptionChanged(deliverySettings.Post,$event)"
                            [checked]="setChecked(deliveryType$|async,deliverySettings.Post)">
                            <span langkey="phWebvoucher_Detail_Post_Delivery"></span>
                            <div>
                              <ng-container
                                *ngIf="isPostDeliveryFree(settings.delivery_costs); then freeDelivery else costDelivery">
                              </ng-container>
                              <ng-template #freeDelivery>
                                <span class="webVoucher-delivery__info"
                                  langkey="phWebvoucher_Detail_Free_Delivery"></span>
                              </ng-template>
                              <ng-template #costDelivery>
                                <div class="webVoucher_delivery__post">
                                  <span class="webVoucher-delivery__info"
                                    langkey="phWebvoucher_Detail_Plus_Cost_Delivery"></span>
                                  <span
                                    class="webVoucher-delivery__costs">{{priceFormatter(settings.delivery_costs)}}</span>
                                </div>
                              </ng-template>
                            </div>
                          </mat-radio-button>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="usePostDelivery(settings.delivery_settings)">
                      <div class="webVoucher-delivery__selector">
                        <mat-radio-button [disableRipple]="true" [value]="deliverySettings.Post" [checked]="true">
                          <span langkey="phWebvoucher_Detail_Post_Delivery"></span>
                          <ng-container
                            *ngIf="isPostDeliveryFree(settings.delivery_costs); then freeDelivery else costDelivery">
                          </ng-container>
                          <ng-template #freeDelivery>
                            <span class="webVoucher-delivery__info" langkey="phWebvoucher_Detail_Free_Delivery"></span>
                          </ng-template>
                          <ng-template #costDelivery>
                            <div class="webVoucher_delivery__post">
                              <span class="webVoucher-delivery__info"
                                langkey="phWebvoucher_Detail_Plus_Cost_Delivery"></span>
                              <span
                                class="webVoucher-delivery__costs">{{priceFormatter(settings.delivery_costs)}}</span>
                            </div>
                          </ng-template></mat-radio-button>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="useMailDelivery(settings.delivery_settings)">
                      <div class="webVoucher-delivery__selector">
                        <mat-radio-button [disableRipple]="true" [value]="deliverySettings.Mail" [checked]="true">
                          <span langkey="phWebvoucher_Detail_Email_Delivery"></span>
                          <span class="webVoucher-delivery__info"
                            langkey="phWebvoucher_Detail_Free_Delivery"></span></mat-radio-button>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <ng-container *ngIf="displayTabs(webVoucher.has_preview)">
          <mat-tab>
            <div class="webVoucher-overview">
              <ng-template mat-tab-label>
                <span a11y_Button langkey="phWebVoucher_Detail_Tab_Preview"></span>
              </ng-template>
              <div class="webVoucher-item__layout">
                <div class="aspect-ratio-box webVoucher-item__img">
                  <div class="aspect-ratio-box-inside">
                    <div class="aspect-ration-img-box">
                      <img class="ya_image" [src]="webVoucher.preview" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
        </ng-container>
      </mat-tab-group>
      <ng-container *ngIf="matGroupSelectedIndex!==1">
        <div class="buying" [ngClass]="!webVoucher.has_preview?'buying-content--center':'buying-content--right'">
          <div class="amountselector webshop-button webshop-button--hollow">
            <ng-container *ngIf="webVoucherCount$ | async; let webVoucherCount">
              <div class="amount amount-input amount-count-content">
                <div class="amountchanger" (click)="decrementCount(webVoucherCount)"><span>-</span></div>
                <div class="amount">
                  <input a11y_SpinButton class="amount-count-input" type="text" [ngModel]="webVoucherCount"
                    (ngModelChange)="changeCount($event);" maxlength="2" numericInput [placeholder]="webVoucherCount"
                    (keypress)="onKeyPress($event)" inputmode="numeric" onpaste="return false;" oncopy="return false"
                    tabindex="-1" pattern="[0-9]*" inputmode="numeric" oncut="return false" ondrag="return false"
                    ondrop="return false" (blur)="onBlurAmount()" (focus)="onFocusAmount($event)">
                </div>
                <div class="amountchanger" (click)="incrementCount(webVoucherCount)"><span>+</span></div>
              </div>
            </ng-container>
          </div>
          <div class="price-button-container">
            <ng-container *ngIf="isAddtoCardButtonActive(webVoucher.price);then addToCart else addToCartDisabled">
            </ng-container>
            <ng-template #addToCart>
              <div class="webshop-button addToBasketBtn" (click)="addToBasket($event)">
                <div class="price">{{setSum(sum$|async)}}</div>
                <div class="inline-icon price-img" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
              </div>
            </ng-template>
            <ng-template #addToCartDisabled>
              <div class="webshop-button webshop-button--disabled addToBasketBtn">
                <div class="price">{{setSum(webVoucher.price)}}</div>
                <div class="inline-icon price-img" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>